import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/ingestion`;

export const ingestionService = {
  uploadFile: async (file, metadata = {}) => {
    const formData = new FormData();
    formData.append('file', file);
    if (metadata.source_system_id) formData.append('source_system_id', metadata.source_system_id);
    if (metadata.uploaded_by) formData.append('uploaded_by', metadata.uploaded_by);
    if (metadata.external_system_id) formData.append('external_system_id', metadata.external_system_id);
    if (metadata.external_system_ref) formData.append('external_system_ref', metadata.external_system_ref);
    const response = await axios.post(`${API_BASE}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  registerExternal: async (data) => {
    const response = await axios.post(`${API_BASE}/external`, data);
    return response.data;
  },

  listFiles: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.source_system_id) params.append('source_system_id', filters.source_system_id);
    if (filters.status) params.append('status', filters.status);
    if (filters.elm_is_sor !== undefined) params.append('elm_is_sor', filters.elm_is_sor);
    if (filters.file_type) params.append('file_type', filters.file_type);
    if (filters.search) params.append('search', filters.search);
    if (filters.limit) params.append('limit', filters.limit);
    if (filters.offset) params.append('offset', filters.offset);
    const response = await axios.get(`${API_BASE}/files?${params}`);
    return response.data;
  },

  getFile: async (id) => {
    const response = await axios.get(`${API_BASE}/files/${id}`);
    return response.data;
  },

  getCustody: async (id) => {
    const response = await axios.get(`${API_BASE}/files/${id}/custody`);
    return response.data;
  },

  verifyIntegrity: async (id) => {
    const response = await axios.get(`${API_BASE}/files/${id}/verify`);
    return response.data;
  },

  updateStatus: async (id, status, actor) => {
    const response = await axios.put(`${API_BASE}/files/${id}/status`, { status, actor });
    return response.data;
  },

  updateSoR: async (id, elmIsSor) => {
    const response = await axios.put(`${API_BASE}/files/${id}/sor`, { elm_is_sor: elmIsSor });
    return response.data;
  },

  getSample: async (id, maxRows = 20) => {
    const response = await axios.get(`${API_BASE}/files/${id}/sample?max_rows=${maxRows}`);
    return response.data;
  },

  getStatistics: async (sourceSystemId) => {
    const params = sourceSystemId ? `?source_system_id=${sourceSystemId}` : '';
    const response = await axios.get(`${API_BASE}/statistics${params}`);
    return response.data;
  }
};

export default ingestionService;
